import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

// Custom hook to check authentication status
const useAuth = () => {
  // This is where you'd implement your actual auth check logic
  // For example, checking a JWT token in localStorage or a global auth state
  const logged = useSelector((state: any) => state.listingReducer.logged);
  const checkAuth = () => {
    return logged; // Returns true if token exists
  };

  return {
    isAuthenticated: checkAuth(),
  };
};

// Protected Route wrapper component
export const ProtectedRoute = ({ redirectPath = "/login" }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // Save the attempted URL to redirect back after login
    return <Navigate to={redirectPath} state={{ from: location }} replace />;
  }

  return <Outlet />;
};
